/**
 * SIG Clone Parent Route
 *
 * This is a pathless layout route that wraps all /sig/* routes.
 * It provides a shared layout context for the SIG Clone module.
 *
 * Routes under this layout:
 * - /sig/clients - Client management
 * - /sig/reports/* - Financial reports
 * - /sig/cashflow - Cashflow management
 * - /sig/timesheet - Timesheet imports
 * - /sig/technical-notes - Technical notes CRUD
 */
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/sig')({
  component: SigLayout,
})

function SigLayout() {
  return <Outlet />
}
